import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RMSPlanReviewScheduleService } from '../../../../shared/services/rmsPlanReviewSchedule.service';
import { RMSPlanChecklistService } from '../../../../shared/services/rmsPlanChecklist.service';

@Component({
  selector: 'review-rms-plan-checklist',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-rms-plan-checklist.component.html',
  styleUrl: './review-rms-plan-checklist.component.css'
})
export class ReviewRmsPlanChecklistComponent {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  rmsPlanChecklist: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Immediate Concerns and Safety Measures",
      children: [
        {
          type: 'number',
          questionText: "Medical Care",
          answer: "medical_care"
        },
        {
          type: 'number',
          questionText: "Emergency Medical Response/Ambulance",
          answer: "emergency_medical_response"
        },
        {
          type: 'number',
          questionText: "School Nurse",
          answer: "school_nurse"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "medical_care_planning_notes"
        },
        {
          type: 'number',
          questionText: "Law Enforcement Involvement",
          answer: "law_enforcement_involvement"
        },
        {
          type: 'number',
          questionText: "No Action Taken",
          answer: "no_action_taken"
        },
        {
          type: 'number',
          questionText: "Ticketed/Charged",
          answer: "ticketed_charged"
        },
        {
          type: 'number',
          questionText: "Arrested/Detained",
          answer: "arrested_detained"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "law_enforcement_planning_notes"
        },
        {
          type: 'number',
          questionText: "Home visit to check for weapons/dangerous materials",
          answer: "home_visit"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "home_visit_notes"
        },
        {
          type: 'number',
          questionText: "Intended victim warned and/or parents/guardians notified",
          answer: "intended_victim"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "intended_victim_notes"
        },
        {
          type: 'number',
          questionText: "Suicide Risk Assessment/Screening completed",
          answer: "suicide_risk"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "suicide_risk_notes"
        },
        {
          type: 'number',
          questionText: "Mental Health Evaluation",
          answer: "mental_health_evaluation"
        },
        {
          type: 'number',
          questionText: "Parent Taking Student to Hospital/ER",
          answer: "parent_student_hospital"
        },
        {
          type: 'number',
          questionText: "Ambulance",
          answer: "ambulance"
        },
        {
          type: 'number',
          questionText: "Other",
          answer: "other"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "mental_health_evaluation_notes"
        },
        {
          type: 'number',
          questionText: "Child Abuse Report to Department of Human Services",
          answer: "child_abuse_report"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "child_abuse_report_notes"
        },
        {
          type: 'number',
          questionText: "Additional Measures to Ensure Safety",
          answer: "additional_measures"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "additional_measures_notes"
        },
        {
          type: 'number',
          questionText: "Does this section require one or more assigned responsibilities to manage and support in the ROAR?",
          answer: "require_roar"
        },
      ]
    },
    {
      sectionName: "Notifications",
      children: [
        // District Notification
        {
          type: 'number',
          questionText: "District Administration",
          answer: "district_notification"
        },
        {
          type: 'informed',
          questionText: "Informed:",
          answer: "district_informed"
        },
        {
          type: 'string',
          questionText: "By Whom:",
          answer: "district_informant"
        },
        {
          type: 'date',
          questionText: "On:",
          answer: "district_informed_date"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "district_informed_notes"
        },
        // Staff and Teachers
        {
          type: 'number',
          questionText: "Staff and Teachers",
          answer: "staff_teachers_notification"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "staff_teachers_informed_notes"
        },
        // Community & Public Notification
        {
          type: 'number',
          questionText: "Community and/or Public Notification(s)",
          answer: "community_notification"
        },
        {
          type: 'informed',
          questionText: "Informed:",
          answer: "community_informed"
        },
        {
          type: 'string',
          questionText: "By Whom:",
          answer: "community_informant"
        },
        {
          type: 'date',
          questionText: "On:",
          answer: "community_informed_date"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "community_informed_notes"
        },
        // Law Enforcement Notification
        {
          type: 'number',
          questionText: "Law Enforcement",
          answer: "law_enforcement_notification"
        },
        {
          type: 'informed',
          questionText: "Informed:",
          answer: "law_enforcement_informed"
        },
        {
          type: 'string',
          questionText: "By Whom:",
          answer: "law_enforcement_informant"
        },
        {
          type: 'date',
          questionText: "On:",
          answer: "law_enforcement_informed_date"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "law_enforcement_informed_notes"
        },
        {
          type: 'number',
          questionText: "Does this section require one or more assigned responsibilities to manage and support in the ROAR?",
          answer: "notifications_roar_needed"
        }
      ]
    },
    {
      sectionName: "Code of Conduct",
      children: [
        {
          type: 'number',
          questionText: "Disciplinary action has been, will be, or needs to be taken.",
          answer: "code_of_conduct"
        },
        {
          type: 'number',
          questionText: "Disciplinary action has already been taken.",
          answer: "disciplinary_action_taken"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "disciplinary_action_taken_notes"
        },
        {
          type: 'string',
          questionText: "Please describe the action taken (i.e. suspension, expulsion, other)",
          answer: "action_taken"
        },
        {
          type: 'number',
          questionText: "Out-of-School Suspension?",
          answer: "suspension"
        },
        {
          type: 'date',
          questionText: "Out-of-School Suspension Return Date:",
          answer: "suspension_return_date"
        },
        {
          type: 'number',
          questionText: "One or more ROAR assignments will be needed for this determination.",
          answer: "action_roar_assignments"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "roar_assignments_planning_notes"
        }
      ]
    },
    {
      sectionName: "Intervention and Monitoring Consideration",
      children: [
        { 
          type: 'number',
          questionText: 'Increased contact/monitoring of subject (Routine check-ins - Daily, Weekly, Other)',
          answer: 'increased_contact'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'increased_contact_notes'
        },
        {      
          type: 'number',
          questionText: 'Travel card to hold accountable for whereabouts and on-time arrival to destinations',
          answer: 'travel_card'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'travel_card_notes'
        },
        {      
          type: 'number',
          questionText: 'Backpack, coat, and other belongings checked in/out',
          answer: 'backpack'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'backpack_planning_notes'
        },
        {      
          type: 'number',
          questionText: 'Late arrival and/or early dismissal',  
          answer: 'late_arrival'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'late_arrival_planning_notes'
        },
        {      
          type: 'number',
          questionText: 'Increased supervision in specific settings',  
          answer: 'increased_supervision'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'increased_supervision_notes'
        },
        {      
          type: 'number',
          questionText: 'Modify Daily Schedule',  
          answer: 'modify_schedule'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'modify_schedule_notes'
        },
        {      
          type: 'number',
          questionText: 'Plan to address harm to self or others created',  
          answer: 'address_harm_self'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'address_harm_self_notes'
        },
        {      
          type: 'number',
          questionText: 'Plan to address future behavior',  
          answer: 'future_behavior'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'future_behavior_notes'
        },
        {      
          type: 'number',
          questionText: 'Plan to address safety',  
          answer: 'safety'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'safety_notes'
        },
        {      
          type: 'number',
          questionText: 'Plan to address containment',  
          answer: 'containment'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'containment_notes'
        },
        {      
          type: 'number',
          questionText: 'Intervention by support staff (Psychologist, Social Worker, Counselor, MTSS Team, etc.)',  
          answer: 'support_staff_intervention'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'support_staff_intervention_plan'
        },
        {      
          type: 'number',
          questionText: 'Behavioral assessment',  
          answer: 'behavioral_assessment'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'behavioral_assessment_notes'
        },
        {      
          type: 'number',
          questionText: 'Positive reinforcements for positive behavior (ROAR should include list of positive behaviors and agreed-upon reinforcements)',  
          answer: 'positive_reinforcement'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'positive_reinforcement_notes'
        },
        {      
          type: 'number',
          questionText: 'Peer or affective needs support group',  
          answer: 'support_group'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'support_group_notes'
        },
        {      
          type: 'number',
          questionText: 'Peer support',  
          answer: 'peer_support'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'peer_support_notes'
        },
        {      
          type: 'number',
          questionText: 'Intervention by community agency (Probation, Diversion, Child Welfare, 1451, etc.)',  
          answer: 'community_intervention'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'community_intervention_notes'
        },
        {      
          type: 'number',
          questionText: 'Identify precipitating/aggravating circumstances and create intervention to alleviate tension',  
          answer: 'alleviate_circumstances'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'alleviate_circumstances_notes'
        },
        {      
          type: 'number',
          questionText: 'Drug and/or alcohol intervention',  
          answer: 'intervention'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'intervention_notes'
        },
        {      
          type: 'number',
          questionText: 'Referral to intervention team',  
          answer: 'intervention_team'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'intervention_team_notes'
        },
        {      
          type: 'number',
          questionText: 'Pro-social discipline (Restorative Justice, community service, etc.)',  
          answer: 'discipline'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'discipline_notes'
        },
        {      
          type: 'number',
          questionText: 'Schedule review of IEP or 504 to review goals and placement options',  
          answer: 'schedule_review'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'schedule_review_notes'
        },
        {      
          type: 'number',
          questionText: 'Virtual/Distance Learning',  
          answer: 'virtual_learning'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'virtual_learning_notes'
        },
        {      
          type: 'number',
          questionText: 'Alternative School/Setting',  
          answer: 'alternative_school'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'alternative_school_notes'
        },
        {      
          type: 'number',
          questionText: 'Other Actions',  
          answer: 'other_actions'
        },
        { 
          type: 'string',
          questionText: 'Planning Notes:',
          answer: 'other_actions_notes'
        },
      ]
    },
    {
      sectionName: "Parent/Guardian Follow Up Steps",
      children: [
        {
          type: 'string',
          questionText: "Parents or guardians will provide the following supervision and/or intervention:",
          answer: "parent_follow_up"
        },
        {
          type: 'string',
          questionText: "Describe/explain:",
          answer: "parent_follow_up_notes"
        },
        {
          type: 'number',
          questionText: "Does this section require one or more assigned responsibilities to manage and support in the ROAR?",
          answer: "parent_follow_up_roar"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "user_date_time"
        }
      ]
    },
  ];

  constructor(
    private rmsPlanChecklistService: RMSPlanChecklistService
  ) { }

  ngOnInit(): void {
    this.loadRmsPlanScheduleForm();
  }

  loadRmsPlanScheduleForm(): void {
    if (this.caseId) {
      this.loading = true;
      this.rmsPlanChecklistService.getRmsPlanChecklistByCaseId(this.caseId).subscribe({
        next: (response) => {
          if (Object.keys(response).length === 0) {
            this.rmsPlanChecklist = null;
            this.loading = false;
            return
          } else {
            this.rmsPlanChecklist = response;
            this.loading = false;
            return
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
  }


  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

  showInformed(answer: number): string {
    switch (answer) {
      case 0: return 'needs to be informed';
      case 1: return 'has been informed';
      case null: return '';
      case undefined: return '';
      default: return 'N/A';
    }
  }


}
